export enum WarningType {
    Warning = "warning",
    Error = "error"
};
